export * as segmentationRuleLibrary from './index';
